<template>
  <div>
    <div class="payment-failed">
      <div class="overlay">
        &nbsp;
      </div>
      <div class="outer">
        <div class="inner">
          <div class="title">
            <h3>Payment Failed</h3>
          </div>
          <div class="receipt-details">
            <div class="receipt-no">
              <strong>Receipt No:</strong> {{ receiptNo }}
            </div>

            <div class="status">
              <strong>Status:</strong> {{ status }}
            </div>
            <div class="status-subcode">
              <strong>SubCode:</strong> {{ statusSubCode }}
            </div>
            <div class="status-message">
              <strong>Status Text:</strong> {{ statusMsg }}
            </div>

            <div class="inv-no">
              <strong>Inv No:</strong> {{ txnid }}
            </div>
            <div class="inv-date">
              <strong>Inv Date:</strong> {{ txnDate }}
            </div>
            <div class="inv-amount">
              <strong>Invoice Amount:</strong> $ {{ invoiceAmount }}
            </div>
            <div>
              <a href="javascript:window.history.back()">Go Back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-failed',
  props: {
    receipt: {
      type: Object,
      required: true
    }
  },
  computed: {
    txnid: function() {
      return this.receipt.transaction.txnid
    },
    receiptNo: function() {
      return this.receipt.receiptno
    },
    txnDate: function() {
      return new Date(this.receipt.transaction.txndate).toISOString()
    },
    invoiceAmount: function() {
      return parseFloat(this.receipt.transaction.invTotal).toFixed(2)
    },
    status: function() {
      return this.receipt.status
    },
    statusSubCode: function() {
      return this.receipt.statuscode
    },
    statusMsg: function() {
      return this.receipt.statusmsg
    }
  }
}
</script>

<style lang='scss' scoped>

  .payment-failed .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .payment-failed .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px 0px #00000040;
  }

  .payment-failed .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

</style>
